import { makeAutoObservable } from 'mobx';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { FilterStore } from '../../shared/util-stores';
import { HandleGetDataReturn } from '../../shared/util-stores/FilterStore/FilterStore';
import { SpringFiltration } from '../../shared/interfaces/SpringFiltration';
import { RecipeListItem } from '../interfaces/RecipeListItem';
import { recipesService } from '../services/recipesService';
import { RecipesFilterData } from '../interfaces/RecipesFilters';

class RecipesListStore {
  recipesList: RecipeListItem[] = [];
  filterMethods: FilterStore<RecipesFilterData>;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<RecipesFilterData>(this.handleGetRecipes);
  }

  setDefaultValues() {
    this.recipesList = [];
    this.filterMethods.setDefaultValues();
  }

  private async handleGetRecipes(
    filterInfo: SpringFiltration<RecipesFilterData>,
  ): Promise<HandleGetDataReturn> {
    const data = await recipesService.getRecipes(filterInfo);
    const { items, page, totalElements } = data;

    this.setRecipesList(items);

    return {
      totalPages: page.count,
      number: filterInfo.requestedPage.page,
      content: items,
      totalElements,
    };
  }

  async getRecipesList() {
    return this.filterMethods.getData();
  }

  async changeRecipeState(recipeId: number, ban: boolean) {
    await recipesService.changeRecipeState(recipeId, ban);
    await this.filterMethods.getData();
  }

  async deleteRecipe(recipeId: number) {
    await recipesService.deleteRecipe(recipeId);
    await this.filterMethods.getData();
  }

  private setRecipesList(recipesList: RecipeListItem[]) {
    this.recipesList = recipesList;
  }
}

const recipesListStore = new RecipesListStore();

resetAllStore.addResetMethod(recipesListStore.setDefaultValues);

export { recipesListStore, RecipesListStore };
